import { render, staticRenderFns } from "./FranchiseClinicCustomProductsList.vue?vue&type=template&id=9e82908e&"
import script from "./FranchiseClinicCustomProductsList.vue?vue&type=script&lang=js&"
export * from "./FranchiseClinicCustomProductsList.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseClinicCustomProductsList.vue?vue&type=style&index=0&id=9e82908e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports